/** @jsx jsx */
import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { jsx, css } from "@emotion/core"
import styled from "@emotion/styled"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"
import { toast } from "react-toastify"
import InputMask from "react-input-mask"
import PhoneInput from "react-phone-number-input"
import "react-phone-number-input/style.css"
import { useFirebase } from "gatsby-plugin-firebase"

import Container from "../../../Container"
import Button from "../../../Button"

import Countries from "./countries"

import { fetchCheckPhone } from "../../../../state/app"
import { removeSpecialChars } from "../../../../helpers"
import Loading from "../../../../assets/images/svg/loadingbutton.svg"
// import { initRecaptcha } from '../../../../helpers/firebaseAuth';

const CustomContainer = styled(Container)`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    padding: 120px 0;

    ${theme.queries.small} {
      padding: 20px 0 60px;
    }

    ${theme.queries.large} {
      width: 700px;
    }
  `}
`

const Title = styled.h1`
  ${({ theme }) => css`
    color: ${theme.colors.blue};
    font-weight: bold;
    font-size: 30px;
    line-height: 106.2%;
    width: 210px;
    margin-bottom: 18px;

    ${theme.queries.small} {
      font-size: 23px;
      text-align: left;
      margin-bottom: 20px;
    }
  `}
`

const Description = styled.p`
  ${({ theme }) => css`
    margin-bottom: 35px;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: -0.408px;
    color: #203760;
    width: 172px;

    ${theme.queries.small} {
      margin-bottom: 35px;
    }
  `}
`

const Label = styled.p`
  ${({ theme }) => css`
    margin-bottom: 10px;
    font-size: 12px;
    line-height: 17px;
    letter-spacing: -0.408px;
    color: #94a6c5;

    ${theme.queries.small} {
      font-size: 12px;
    }
  `}
`

const InputContainer = styled.div`
  display: flex;
  max-width: 404px;

  margin-bottom: 50px;
`

const CustomButton = styled(Button)`
  ${({ theme }) => css`
    width: 100%;
    max-width: 402px;
    text-align: center;
    height: 55px;
    position: relative;
    margin-top: 20px;

    svg {
      position: absolute;
      top: 3px;
      right: 50%;
      transform: translateX(50%);
      height: 50px;
    }

    ${theme.queries.small} {
      font-size: 11pt;
    }
  `}
`

const options = Countries

const CodeInputMask = styled(InputMask)`
  ${({ theme }) => css`
    max-width: 270px;
    width: 100%;
    padding: 16px 31px;
    color: ${theme.colors.blue};
    border-radius: 5px;
    border: 1px solid ${theme.colors.lightGrey};
    font-size: 16px;
    text-align: center;
  `}
`

const Phone = styled(Img)`
  ${({ theme }) => css`
    width: 447px;
    height: 382px;

    ${theme.queries.small} {
      display: none !important;
    }
  `}
`

const hideDesktop = ({ queries }) => css`
  ${queries.medium} {
    display: none;
  }
`

const hideMobile = ({ queries }) => css`
  ${queries.small} {
    display: none !important;
  }
`

const Recaptcha = styled.div`
  max-width: 403px;

  margin-top: -30px;
  align-items: center;
  overflow: hidden;
  height: 78px;
  margin-left: 0px;
`

const BackButton = styled.button`
  ${({ theme }) => css`
    background-color: transparent;
    border: none;
    cursor: pointer;
    text-decoration: underline;
    color: ${theme.colors.grey};
    padding: 10px;
    width: 100%;
    text-align: center;
    max-width: 402px;
    margin-top: 15px;
  `}
`

const AuthenticationStep = ({
  setStep,
  dispatch,
  setFacebookCode,
  setLoginPhone,
  phoneRecognized,
  setEmailToConfirmation,
  translation,
}) => {
  const [firebaseImpl, setFirebase] = useState(null)
  const [phoneNumber, setInputPhoneNumber] = useState("")
  const [phone, setPhone] = useState("")
  const [isValid, setValidation] = useState(true)
  const [recaptchaToken, setRecaptchaToken] = useState(null)
  const [trueRecaptcha, setRecaptcha] = useState(null)
  const [recaptchaRef, setRecaptchaRef] = useState(null)

  //insert code step
  const [confirmationResult, setConfirmationResult] = useState(null)
  const [verificationId, setVerificationId] = useState(null)
  const [isCodeValid, setCodeValid] = useState("")
  const [code, handleCode] = useState("")

  const [isLoading, setLoading] = useState(true)
  useFirebase(firebase => {
    setFirebase(firebase)

    firebase.auth().languageCode = translation.currentLang
    const recaptcha = new firebase.auth.RecaptchaVerifier(
      "recaptcha-container",
      {
        size: "normal",
        callback: function(response) {
          setRecaptchaToken(response)
        },
      }
    )
    setRecaptchaRef(recaptcha)

    document.getElementById("recaptcha-container").innerHTML = ""
    setTimeout(() => {
      recaptcha.render().then(() => {
        setRecaptcha(recaptcha)
      })
    }, 50)

    setLoading(false)
  }, [])

  const resendSMS = () => {
    setVerificationId(null)
    setRecaptchaToken(null)
    setTimeout(() => {
      firebaseImpl.auth().languageCode = translation.currentLang
      const recaptcha = new firebaseImpl.auth.RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "normal",
          callback: function(response) {
            setRecaptchaToken(response)
          },
        }
      )

      setRecaptchaRef(recaptcha)

      document.getElementById("recaptcha-container").innerHTML = ""
      setTimeout(() => {
        recaptcha.render().then(() => {
          setRecaptcha(recaptcha)
        })
      }, 10)
    }, 10)
  }
  const sendCode = event => {
    event.preventDefault()
    if (removeSpecialChars(phoneNumber).length > 9) {
      if (recaptchaToken) {
        firebaseImpl
          .auth()
          .signInWithPhoneNumber(
            `+${removeSpecialChars(phoneNumber)}`,
            trueRecaptcha
          )
          .then(function(confirmationResult) {
            setVerificationId(confirmationResult.verificationId)
            setLoginPhone(`+${removeSpecialChars(phoneNumber)}`)
            setConfirmationResult(confirmationResult)
            setLoading(false)
          })
          .catch(function(error) {
            setLoading(false)
            if (error.code === "auth/too-many-requests") {
              toast.error(translation.errorMany)
            } else {
              toast.error(translation.errorSms)
            }
          })
      } else {
        setLoading(false)
        toast.error(translation.confirmRecaptcha)
      }
    } else {
      setLoading(false)
      setValidation(false)
    }
  }

  const confirmCode = e => {
    e.preventDefault()
    setLoading(true)
    if (removeSpecialChars(code).length === 6) {
      confirmationResult
        .confirm(code)
        .then(result => {
          setFacebookCode(firebaseImpl.auth().currentUser.getIdToken())
          dispatch(fetchCheckPhone(`${phoneNumber}`))
            .then(resp => {
              setEmailToConfirmation(resp.data.emailMask)
              setStep(2)
              setLoading(false)
            })
            .catch(err => {
              setLoading(false)

              if (err?.response?.data?.ErrorCode == 404) {
                setStep(3)
                toast.success("Sucesso")
                return
              }

              toast.warning(
                err?.response?.data?.Message || "Erro na autenticação"
              )
            })
        })
        .catch(err => {
          setLoading(false)
          // debugger
          if (err.error) {
            if (err.error.code == "auth/invalid-verification-code") {
              toast.error(translation.errorInvalidCode)
              setCodeValid(translation.errorInvalidCode)
            }
          } else {
            toast.error(translation.errorConfirmationCode)
          }
        })
    } else {
      // debugger
      setCodeValid(translation.errorInvalidCode)
      setLoading(false)
    }
  }

  const data = useStaticQuery(graphql`
    query {
      phone: file(relativePath: { eq: "phone.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      phoneMobile: file(relativePath: { eq: "phone.png" }) {
        childImageSharp {
          fixed(width: 49, height: 91) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  const Error = styled.span`
    ${({ theme }) => css`
      color: ${theme.colors.red};
      font-size: 11px;
      margin-top: 5px;
      /* margin-bottom: 55px; */
      display: block;
      width: 100%;
      margin-left: 134px;
    `}
  `

  return (
    <CustomContainer>
      <div
        css={css`
          width: 350px;
        `}
      >
        <div
          css={theme => css`
            ${theme.queries.large} {
              display: none;
            }
          `}
        >
          <Img
            fixed={data.phoneMobile.childImageSharp.fixed}
            css={theme => css`
              width: auto;
              margin: 30px 0;

              ${theme.queries.large} {
                display: none;
              }
            `}
          />
        </div>

        <Title>{translation.login.step1.blueText1}</Title>
        <Description>{translation.login.step1.greyText1}</Description>

        <Phone css={hideDesktop} fluid={data.phone.childImageSharp.fluid} />

        {!verificationId && (
          <>
            <Label>{translation.login.step1.setPhoneNumber} </Label>

            <form
              onSubmit={sendCode}
              css={css`
                color: #94a6c5;
                margin-bottom: 30px;
              `}
            >
              <InputContainer>
                <div
                  css={theme => css`
                    display: flex;
                    margin: 18px 0 22px;

                    input,
                    select {
                      border: 1px solid #c1c1c1;
                      border-radius: 5px;
                      color: ${theme.colors.jet};
                      font-size: 14px;
                      height: 59px;
                      flex: 1;
                      padding: 20px;
                    }

                    select {
                      margin-right: 11px;
                      max-width: 116px;
                      padding: 0px 20px;
                      -webkit-appearance: none;
                    }

                    ${theme.queries.medium} {
                      width: 400px;

                      input,
                      select {
                        font-size: 20px;
                      }
                    }
                  `}
                >
                  <PhoneInput
                    international
                    defaultCountry="BR"
                    value={phoneNumber}
                    onChange={val => {
                      setInputPhoneNumber(val)
                    }}
                  />
                </div>
              </InputContainer>
              <Error>{!isValid && translation.errors.number}</Error>
              <Recaptcha id="recaptcha-container"></Recaptcha>
              <CustomButton disabled={isLoading} uppercase color="red">
                {isLoading ? (
                  <Loading role="img" />
                ) : (
                  translation.login.step1.sendSMS
                )}
              </CustomButton>
            </form>
          </>
        )}

        {verificationId && (
          <>
            <Label>
              {translation.login.step1.setCode} {phone}
            </Label>

            <form onSubmit={confirmCode}>
              <InputContainer>
                <CodeInputMask
                  mask="999999"
                  maskPlaceholder={null}
                  type="text"
                  onChange={e => handleCode(e.target.value)}
                  value={code}
                  css={({ colors }) =>
                    css`
                      margin: 0 auto;
                      display: block;
                      ${isCodeValid && `border-color: ${colors.red};`}
                    `
                  }
                />
              </InputContainer>
              <Error
                css={css`
                  margin-left: 66px;
                `}
              >
                {isCodeValid}
              </Error>
              <CustomButton disabled={isLoading} uppercase color="red">
                {isLoading ? (
                  <Loading role="img" />
                ) : (
                  translation.login.step1.confirmCode
                )}
              </CustomButton>
              <BackButton onClick={() => resendSMS()}>
                {translation.login.step1.resend}
              </BackButton>
            </form>
          </>
        )}
      </div>
      <div css={hideMobile}>
        <Phone
          fluid={data.phone.childImageSharp.fluid}
          css={theme => css`
            width: 225px;
            height: auto;

            ${theme.queries.small} {
              display: nome !important;
            }
          `}
        />
      </div>
    </CustomContainer>
  )
}

export default connect(
  state => ({
    phoneRecognized: state.app.phoneRecognized,
  }),
  null
)(AuthenticationStep)
